import CategoricalScheme from '../../CategoricalScheme';

const schemes = [
  {
    id: 'sparkColorsTwo',
    label: 'SPARK Colors Two',
    colors: [
      '#815854',
      '#DEA94B',
      '#697BA1',
      '#FEDFDD',
      '#A5E0F0',
      '#D3BFB0',
      '#294B6D',
      '#EFEFB7',
      '#8D00FF',
      '#C69A4F',
      '#C2CBCD',
      '#9AE7B2',
      '#6A6A69',
      '#FA8C9F',
      '#298DFF',
      '#D94497',
      '#FF8401',
      '#4F6D29',
      '#810000',
      '#84B2FE',
      '#FF0079',
      '#E6FC81',
      '#AE97C2',
      '#CB4F64',
      '#FF63FA',
      '#006277',
      '#A46C7F',
      '#B4C258',
      '#FF4800',
      '#3425FF',
    ],
  },
].map(s => new CategoricalScheme(s));

export default schemes;
